<template>
  <div id="app">
<!--    <keep-alive>-->
<!--      <router-view v-if="isRouterAlive"></router-view>-->
<!--    </keep-alive>-->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
// import UUID from 'vue-uuid'
import {v1 as uuidV1} from 'uuid'
import Global from './utils/book_global'
import Cookies from 'js-cookie';

export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    initUUid(){
      Global.State.uuid = this.common.getUUID();
    },
  },
  mounted: function (){
    this.initUUid();
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

}

.el-message-box{
  width: 85%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue